import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
        path: "/",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../views/cards/Overview.vue"),
    },
    {
        path: "/card-profile",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../views/CardProfile.vue"),
    },
    {
        path: "/cards",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../views/cards/Overview.vue"),
    },

    {
        path: "/cards/:id",
        component: () =>
            import ( /* webpackChunkName: "orders" */ "../views/cards/__template.vue"),
        children: [{
            path: "",
            component: () =>
                import ( /* webpackChunkName: "about" */ "../views/cards/Card.vue"),
        }, ],
    },
    {
        path: "/profiles/create",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../views/profiles/ProfileCreate.vue"),
    },
    {
        path: "/profiles",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../views/profiles/Overview.vue"),
    },

    {
        path: "/profiles/:id",
        component: () =>
            import (
                /* webpackChunkName: "orders" */
                "../views/profiles/__template.vue"
            ),
        children: [{
                path: "",
                component: () =>
                    import (
                        /* webpackChunkName: "about" */
                        "../views/profiles/Profile.vue"
                    ),
            },
            {
                path: "edit-name",
                component: () =>
                    import (
                        /* webpackChunkName: "about" */
                        "../views/profiles/EditName.vue"
                    ),
            },
            {
                path: "edit-emailadres",
                component: () =>
                    import (
                        /* webpackChunkName: "about" */
                        "../views/profiles/EditEmailadres.vue"
                    ),
            },
            {
                path: "edit-functiontitle",
                component: () =>
                    import (
                        /* webpackChunkName: "about" */
                        "../views/profiles/EditFunctiontitle.vue"
                    ),
            },
            {
                path: "edit-phone",
                component: () =>
                    import (
                        /* webpackChunkName: "about" */
                        "../views/profiles/EditPhone.vue"
                    ),
            },
            {
                path: "edit-adres",
                component: () =>
                    import (
                        /* webpackChunkName: "about" */
                        "../views/profiles/EditAdres.vue"
                    ),
            },
            {
                path: "profile-settings",
                component: () =>
                    import (
                        /* webpackChunkName: "about" */
                        "../views/profiles/ProfileSettings.vue"
                    ),
            },
        ],
    },
    {
        path: "/companies",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../views/companies/Overview.vue"),
    },

    {
        path: "/companies/:id",
        component: () =>
            import (
                /* webpackChunkName: "orders" */
                "../views/companies/__template.vue"
            ),
        children: [{
            path: "",
            component: () =>
                import (
                    /* webpackChunkName: "about" */
                    "../views/companies/Companie.vue"
                ),
        }, ],
    },
    {
        path: "/support",
        component: () =>
            import ( /* webpackChunkName: "about" */ "../views/Support.vue"),
    },
    {
        path: "/settings",
        component: () =>
            import (
                /* webpackChunkName: "orders" */
                "../views/settings/__template.vue"
            ),
        children: [{
                path: "",
                component: () =>
                    import (
                        /* webpackChunkName: "about" */
                        "../views/settings/Overview.vue"
                    ),
            },
            {
                path: "general",
                component: () =>
                    import (
                        /* webpackChunkName: "about" */
                        "../views/settings/General.vue"
                    ),
            },
        ],
    },
    {
        path: "/:catchAll(.*)",
        component: () =>
            import ( /* webpackChunkName: "404" */ "../views/404.vue"),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});
export default router;